import {
  IconStar,
  IconChevronLeft,
  IconChevronRight,
} from '@tabler/icons-react'
import { useRef, useState } from 'react'
import TrustpilotBadge from './TrustpilotBadge'
import CTAButton from './shared/CTAButton'

const reviews = [
  {
    id: 1,
    rating: 5,
    title: 'Easy to use',
    content: 'Easy to use 👍. Thanks for your help & services.',
    author: 'Christakis',
  },
  {
    id: 2,
    rating: 5,
    title: 'Easy to understand',
    content: 'This was easy to understand, read and fill in.',
    author: 'Patricia Newman',
  },
  {
    id: 3,
    rating: 5,
    title: 'Great easy claim form',
    content: 'Great easy claim form.',
    author: 'Funluvindiva',
  },
  {
    id: 4,
    rating: 5,
    title: 'Quick and easy',
    content: 'Quick and easy to fill out.',
    author: 'Lorraine Welsh',
  },
  {
    id: 5,
    rating: 5,
    title: 'Easy to do',
    content: 'Easy to do did on behalf of an elderly friend.',
    author: 'Malcolm Duncan',
  },
  {
    id: 6,
    rating: 4,
    title: 'Very easy',
    content: 'Very easy but only time will tell if effective.',
    author: 'Mark McKenny',
  },
  {
    id: 7,
    rating: 4,
    title: 'So far so good',
    content:
      "So far so good if Your Claim Matters actually finds all my past car finance and get me some compensation I'll be happy watch this space.",
    author: 'Audrey Smith',
  },
  {
    id: 8,
    rating: 5,
    title: 'Brilliant customer service',
    content:
      'Customer service was brilliant - answered all my questions. Simple process.',
    author: 'Hristiyan Pashkov',
  },
  {
    id: 9,
    rating: 4,
    title: 'Happy with claim management',
    content:
      'Happy with how my claim was managed. Clear communication and fast updates.',
    author: 'Phuong Hang',
  },
  {
    id: 10,
    rating: 5,
    title: 'Smooth experience',
    content:
      'Smooth experience from start to finish. Easy form and helpful team.',
    author: 'Crew Trip',
  },
]

function StarRating({ rating }) {
  return (
    <div className="mb-4">
      <div className="flex gap-0.5">
        {rating === 5 ? (
          <>
            {[...Array(5)].map((_, i) => (
              <IconStar
                key={i}
                className="h-5 w-5 fill-orange-400 text-orange-400"
              />
            ))}
          </>
        ) : rating === 4 ? (
          <>
            {[...Array(4)].map((_, i) => (
              <IconStar
                key={i}
                className="h-5 w-5 fill-orange-400 text-orange-400"
              />
            ))}
            <IconStar className="h-5 w-5 fill-gray-300 text-gray-300" />
          </>
        ) : (
          <>
            {[...Array(5)].map((_, i) => (
              <IconStar
                key={i}
                className={`h-5 w-5 ${
                  i < rating
                    ? 'fill-orange-400 text-orange-400'
                    : 'fill-gray-300 text-gray-300'
                }`}
              />
            ))}
          </>
        )}
      </div>
    </div>
  )
}

function ReviewCard({ review }) {
  return (
    <div className="flex h-full w-full min-w-0 flex-col overflow-hidden rounded-lg bg-white p-4">
      <div className="pt-6">
        <StarRating rating={review.rating} />
      </div>
      <p
        className="overflow-wrap-anywhere mb-4 flex-1 text-sm leading-relaxed break-words"
        style={{ color: 'var(--foreground)' }}
      >
        {review.content}
      </p>
      <div className="text-xs">
        <div
          className="overflow-wrap-anywhere mb-1 font-semibold break-words uppercase"
          style={{ color: 'var(--foreground)' }}
        >
          {review.author}
        </div>
      </div>
    </div>
  )
}

function StatisticsCard() {
  return (
    <div className="h-full w-full min-w-0">
      <div
        className="h-full overflow-hidden rounded-3xl border-0"
        style={{
          background:
            'linear-gradient(to bottom right, #095678 0%, #0d86bc 55%, #ff914d 100%)',
        }}
      >
        <div className="relative flex h-full flex-col justify-between p-6 text-white">
          <div className="relative z-10 flex flex-1 flex-col justify-center">
            <div className="mb-6">
              <h3 className="text-lg leading-tight font-bold break-words sm:text-xl">
                We&apos;ve helped{' '}
                <span className="text-[#ff914d]">hundreds</span> of customers
                get paid compensation
              </h3>
            </div>

            <div className="text-center">
              <div className="flex items-center justify-center gap-2">
                <svg
                  className="h-6 w-6 fill-orange-400 text-orange-400"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
                <div className="text-3xl font-black sm:text-4xl">Excellent</div>
                <svg
                  className="h-6 w-6 fill-orange-400 text-orange-400"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
              </div>
              <div className="mt-2 text-sm font-medium">
                Rated 4.5 on Google
              </div>
            </div>
          </div>

          <div className="relative z-10 mt-4">
            <div className="rounded-lg bg-black/20 px-3 py-2 text-center text-xs sm:text-sm">
              <span className="font-medium break-words">
                Rated excellent on Google by our clients.
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const TOTAL_CARDS = 1 + reviews.length // 1 stats card + review cards

export function Reviews({ className = '' }) {
  const scrollContainerRef = useRef(null)
  const [activeIndex, setActiveIndex] = useState(0)

  const handleScroll = () => {
    if (!scrollContainerRef.current) return
    const card = scrollContainerRef.current.querySelector('[data-card]')
    if (!card) return
    const cardWidth = card.offsetWidth + 16
    setActiveIndex(
      Math.round(scrollContainerRef.current.scrollLeft / cardWidth)
    )
  }

  const scrollToCard = index => {
    const card = scrollContainerRef.current?.querySelector('[data-card]')
    if (!card) return
    scrollContainerRef.current.scrollTo({
      left: index * (card.offsetWidth + 16),
      behavior: 'smooth',
    })
    setActiveIndex(index)
  }

  const scrollLeft = () => {
    const card = scrollContainerRef.current?.querySelector('[data-card]')
    if (!card) return
    const gap = 16 // Account for gap between cards
    scrollContainerRef.current.scrollBy({
      left: -(card.offsetWidth + gap),
      behavior: 'smooth',
    })
  }

  const scrollRight = () => {
    const card = scrollContainerRef.current?.querySelector('[data-card]')
    if (!card) return
    const gap = 16 // Account for gap between cards
    scrollContainerRef.current.scrollBy({
      left: card.offsetWidth + gap,
      behavior: 'smooth',
    })
  }

  return (
    <section className={`w-full bg-gray-100 pt-8 ${className}`}>
      <div className="mx-auto max-w-7xl px-4">
        <div className="mb-8 text-center">
          <h2
            className="text-4xl font-black sm:text-5xl"
            style={{ color: 'var(--foreground)' }}
          >
            OUR CUSTOMERS LOVE US
          </h2>
        </div>

        <div className="mb-12 text-center">
          <div
            className="font-raleway-numbers mb-4 text-lg font-medium sm:text-xl"
            style={{ color: 'var(--foreground)' }}
          >
            Rated excellent by our customers, supported by glowing 4 & 5 star
            reviews on Google.
          </div>
          <div className="flex justify-center">
            <TrustpilotBadge />
          </div>
        </div>

        <div className="relative">
          <div className="flex items-center justify-between">
            <button
              onClick={scrollLeft}
              className="z-10 flex-shrink-0 rounded-full border-2 border-gray-200 bg-white p-3 shadow-lg transition-all duration-300 hover:border-[#0d86bc] hover:bg-gray-50 hover:shadow-xl focus:ring-2 focus:ring-[#0d86bc] focus:outline-none"
              aria-label="Scroll left"
            >
              <IconChevronLeft className="h-6 w-6 text-gray-700" />
            </button>

            <div
              ref={scrollContainerRef}
              onScroll={handleScroll}
              className="scrollbar-hide mx-4 flex flex-1 gap-4 overflow-x-auto py-4"
              style={{ scrollSnapType: 'x mandatory' }}
            >
              <div
                data-card
                className="h-80 w-[calc(100%-2rem)] flex-shrink-0 sm:w-[calc(100%-2rem)] md:w-80"
                style={{ scrollSnapAlign: 'start' }}
              >
                <StatisticsCard />
              </div>
              {reviews.map(review => (
                <div
                  key={review.id}
                  data-card
                  className="h-80 w-[calc(100%-2rem)] flex-shrink-0 sm:w-[calc(100%-2rem)] md:w-80"
                  style={{ scrollSnapAlign: 'start' }}
                >
                  <ReviewCard review={review} />
                </div>
              ))}
            </div>

            <button
              onClick={scrollRight}
              className="z-10 flex-shrink-0 rounded-full border-2 border-gray-200 bg-white p-3 shadow-lg transition-all duration-300 hover:border-[#0d86bc] hover:bg-gray-50 hover:shadow-xl focus:ring-2 focus:ring-[#0d86bc] focus:outline-none"
              aria-label="Scroll right"
            >
              <IconChevronRight className="h-6 w-6 text-gray-700" />
            </button>
          </div>

          {/* Dot pagination */}
          <div className="mt-4 flex justify-center gap-2">
            {[...Array(TOTAL_CARDS)].map((_, i) => (
              <button
                key={i}
                onClick={() => scrollToCard(i)}
                aria-label={`Go to card ${i + 1}`}
                className={`h-2 rounded-full transition-all duration-300 ${
                  i === activeIndex
                    ? 'w-6 bg-[var(--brand-orange)]'
                    : 'w-2 bg-gray-300'
                }`}
              />
            ))}
          </div>
        </div>

        {/* CTA Section */}
        <div className="pt-6 pb-6">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-foreground mb-6 text-3xl font-black sm:text-4xl">
              Ready to Start Your Claim?
            </h2>
            <p className="text-foreground mx-auto mb-8 max-w-2xl text-lg">
              Let our experienced team help you recover the money you may be
              owed from your car finance agreement.
            </p>
            <div className="mb-4">
              <CTAButton />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Reviews
